import { render, staticRenderFns } from "./CardInputs.vue?vue&type=template&id=65568e95&scoped=true&"
import script from "./CardInputs.ts?vue&type=script&lang=ts&"
export * from "./CardInputs.ts?vue&type=script&lang=ts&"
import style0 from "./CardInputs.scss?vue&type=style&index=0&id=65568e95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65568e95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
